import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Contract, ContractsEntityState } from '../../interfaces';
import {
    ContractsFeatureName,
    ContractsFeatureAdapter,
} from './contracts.reducer';

const EntitySelectors = ContractsFeatureAdapter.getSelectors();

const getContractsLoadedState = ({ loaded }: ContractsEntityState): boolean =>
    loaded;

const getContractHasSelected = ({
    hasSelected,
}: ContractsEntityState): boolean => hasSelected;

const getContractSelected = ({
    selected,
    entities,
}: ContractsEntityState): Contract | undefined => entities[selected];

const getContractSelectedName = (
    state: ContractsEntityState
): string | undefined => getContractSelected(state)?.name;

const getContractSelectedVendorName = (
    state: ContractsEntityState
): string | undefined => getContractSelected(state)?.vendorName;

const getContractSelectedState = (
    state: ContractsEntityState
): string | undefined => getContractSelected(state)?.state;

const getContractById =
    (id: string) =>
    ({ entities }: ContractsEntityState): Contract | undefined =>
        entities[id];

const getContractSelectedId = ({ selected }: ContractsEntityState): string =>
    selected;

export const ContractListFeatureSelector =
    createFeatureSelector<ContractsEntityState>(ContractsFeatureName);

export const getContractListSelector = createSelector(
    ContractListFeatureSelector,
    EntitySelectors.selectAll
);

export const getContractSelectedIdSelector = createSelector(
    ContractListFeatureSelector,
    getContractSelectedId
);

export const getContractSelectedSelector = createSelector(
    ContractListFeatureSelector,
    getContractSelected
);

export const getContractSelectedNameSelector = createSelector(
    ContractListFeatureSelector,
    getContractSelectedName
);

export const getContractSelectedVendorNameSelector = createSelector(
    ContractListFeatureSelector,
    getContractSelectedVendorName
);

export const getContractSelectedStateSelector = createSelector(
    ContractListFeatureSelector,
    getContractSelectedState
);

export const getContractHasSelectedStateSelector = createSelector(
    ContractListFeatureSelector,
    getContractHasSelected
);

export const getIsLoadedLeaseListSelector = createSelector(
    ContractListFeatureSelector,
    getContractsLoadedState
);

export const getContractByIdSelector = (id: string) =>
    createSelector(ContractListFeatureSelector, getContractById(id));

export const getContractNameByIdSelector = (id: string) =>
    createSelector(ContractListFeatureSelector, getContractById(id));
